import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { OshDangerousSituationItemComponent } from '@app/components/osh/osh-dangerous-situation-item/osh-dangerous-situation-item.component';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { CreateOrEditOshAnalysisDialogData, Osh } from '@app/shared/types/models/osh/osh.model';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-osh-tree-item',
  imports: [MatIconModule, TranslatePipe, MatMenuModule, OshDangerousSituationItemComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './osh-tree-item.component.html'
})
export class OshTreeItemComponent {
  private readonly dialogService: DialogService = inject(DialogService);
  private readonly translateService: TranslateService = inject(TranslateService);
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);

  protected dangerousSituationVisible = false;
  protected activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;

  public readonly oshAnalysisEdited: OutputEmitterRef<CreateOrEditOshAnalysisDialogData> =
    output<CreateOrEditOshAnalysisDialogData>();
  public readonly oshAnalysisDeleted: OutputEmitterRef<string> = output<string>();
  public readonly oshAnalysis: InputSignal<Osh> = input.required<Osh>();

  protected toggleChildren(): void {
    this.dangerousSituationVisible = !this.dangerousSituationVisible;
  }

  protected editAnalysis(oshAnalysis: Osh): void {
    this.dialogService
      .openEditOshAnalysisDialog({ id: this.activeCompany()?.id, oshAnalysis: oshAnalysis })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.oshAnalysisEdited.emit(result);
        }
      });
  }

  protected deleteAnalysis(oshAnalysis: Osh): void {
    this.dialogService
      .openConfirmationDialog({
        title: this.translateService.instant('osh.modals.delete-title'),
        desc: this.translateService.instant('osh.modals.delete-description', {
          name: oshAnalysis.workType.value
        })
      })
      .afterClosed()
      .subscribe(decision => {
        if (decision) {
          this.oshAnalysisDeleted.emit(oshAnalysis.id);
        }
      });
  }
}
